import HNSColors from "../../../../ui library/HNSColors";

export function getPdfReportBaseStyles() {
  return `
    @page { size: 8.5in 11in; margin: 0.7in; }
    body { font-family: Arial, sans-serif; color: ${HNSColors.neutrals[100]}; margin: 0; }
    *, *::before, *::after { box-sizing: border-box; }
    img { display: block; max-width: 100%; }
    .pdf-report-page {
      break-inside: avoid-page;
      page-break-inside: avoid;
    }
    .pdf-report-page + .pdf-report-page { break-before: page; page-break-before: always; }
    .pdf-report-banner { margin-bottom: 24px; }
    .pdf-report-section { margin-bottom: 28px; }
    .pdf-report-section-title { margin: 0 0 12px; }
    .text-center { text-align: center; }
    .text-right { text-align: right; }
  `;
}
